import { useFragmentsDeliveryAPIStationConfigClientGetConfig } from '@mi-front/api-clients';
import { Station } from '@app/core/types/stations';

/**
 * Whether external (fragments delivery) export is enabled for the station.
 * Uses the generated station-config hook so React Query dedupes with other consumers.
 */
export function useIsExternalExportEnabled(station: Station | undefined) {
  const query = useFragmentsDeliveryAPIStationConfigClientGetConfig(station?.id ?? '', {
    query: { enabled: !!station?.id },
  });

  return query.data?.enabled;
}
